import type { CMSConfig } from '#types/config/components/cms'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    container: 'space-y-2 <md:bg-transparent md:(p-6 -mx-6)',
    containerWrapper: 'px-4 lg:px-6'
  },
} satisfies RecursivePartial<CMSConfig['imageBanner']>
